import { Contract, constants, BigNumber, utils as utils$1 } from 'ethers';
import { _TypedDataEncoder } from '@ethersproject/hash';
import { keccak256 } from 'ethers/lib/utils';
import { MerkleTree } from 'merkletreejs';
import * as multicall from '@0xsequence/multicall';
import { keccak256 as keccak256$1 } from 'js-sha3';

var abiIERC721 = [
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "approved",
				type: "address"
			},
			{
				indexed: true,
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "operator",
				type: "address"
			},
			{
				indexed: false,
				internalType: "bool",
				name: "approved",
				type: "bool"
			}
		],
		name: "ApprovalForAll",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: true,
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				internalType: "uint256",
				name: "balance",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			}
		],
		name: "getApproved",
		outputs: [
			{
				internalType: "address",
				name: "operator",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "operator",
				type: "address"
			}
		],
		name: "isApprovedForAll",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			}
		],
		name: "ownerOf",
		outputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			}
		],
		name: "safeTransferFrom",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "safeTransferFrom",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "operator",
				type: "address"
			},
			{
				internalType: "bool",
				name: "_approved",
				type: "bool"
			}
		],
		name: "setApprovalForAll",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var abiIERC20 = [
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

// ER721 and ERC1155
const setApprovalForAll = (signer, collection, operator, approved, overrides) => {
    const contract = new Contract(collection, abiIERC721, signer);
    return contract.setApprovalForAll(operator, approved, Object.assign({}, overrides));
};
const isApprovedForAll = (signerOrProvider, collection, account, operator, overrides) => {
    const contract = new Contract(collection, abiIERC721, signerOrProvider);
    return contract.isApprovedForAll(account, operator, Object.assign({}, overrides));
};
// ERC20
const allowance = (signerOrProvider, currency, account, operator, overrides) => {
    const contract = new Contract(currency, abiIERC20, signerOrProvider);
    return contract.allowance(account, operator, Object.assign({}, overrides));
};
const approve = (signer, currency, operator, amount, overrides) => {
    const contract = new Contract(currency, abiIERC20, signer);
    return contract.approve(operator, amount, Object.assign({}, overrides));
};
const balanceOf = (signerOrProvider, currency, account, overrides) => {
    const contract = new Contract(currency, abiIERC20, signerOrProvider);
    return contract.balanceOf(account, Object.assign({}, overrides));
};

var tokens = /*#__PURE__*/Object.freeze({
  __proto__: null,
  allowance: allowance,
  approve: approve,
  balanceOf: balanceOf,
  isApprovedForAll: isApprovedForAll,
  setApprovalForAll: setApprovalForAll
});

var abi$2 = [
	{
		inputs: [
			{
				internalType: "address",
				name: "_owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "_protocolFeeRecipient",
				type: "address"
			},
			{
				internalType: "address",
				name: "_transferManager",
				type: "address"
			},
			{
				internalType: "address",
				name: "_weth",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
		],
		name: "CallerInvalid",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ChainIdInvalid",
		type: "error"
	},
	{
		inputs: [
		],
		name: "CreatorFeeBpTooHigh",
		type: "error"
	},
	{
		inputs: [
		],
		name: "CurrencyInvalid",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ERC20TransferFromFail",
		type: "error"
	},
	{
		inputs: [
		],
		name: "LengthsInvalid",
		type: "error"
	},
	{
		inputs: [
		],
		name: "MerkleProofInvalid",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "length",
				type: "uint256"
			}
		],
		name: "MerkleProofTooLarge",
		type: "error"
	},
	{
		inputs: [
		],
		name: "NewGasLimitETHTransferTooLow",
		type: "error"
	},
	{
		inputs: [
		],
		name: "NewProtocolFeeRecipientCannotBeNullAddress",
		type: "error"
	},
	{
		inputs: [
		],
		name: "NoOngoingTransferInProgress",
		type: "error"
	},
	{
		inputs: [
		],
		name: "NoSelectorForStrategy",
		type: "error"
	},
	{
		inputs: [
		],
		name: "NoncesInvalid",
		type: "error"
	},
	{
		inputs: [
		],
		name: "NotAContract",
		type: "error"
	},
	{
		inputs: [
		],
		name: "NotAffiliateController",
		type: "error"
	},
	{
		inputs: [
		],
		name: "NotOwner",
		type: "error"
	},
	{
		inputs: [
		],
		name: "NotV2Strategy",
		type: "error"
	},
	{
		inputs: [
		],
		name: "NullSignerAddress",
		type: "error"
	},
	{
		inputs: [
		],
		name: "OutsideOfTimeRange",
		type: "error"
	},
	{
		inputs: [
		],
		name: "PercentageTooHigh",
		type: "error"
	},
	{
		inputs: [
		],
		name: "QuoteTypeInvalid",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ReentrancyFail",
		type: "error"
	},
	{
		inputs: [
		],
		name: "RenouncementNotInProgress",
		type: "error"
	},
	{
		inputs: [
		],
		name: "SameDomainSeparator",
		type: "error"
	},
	{
		inputs: [
		],
		name: "SignatureEOAInvalid",
		type: "error"
	},
	{
		inputs: [
		],
		name: "SignatureERC1271Invalid",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "length",
				type: "uint256"
			}
		],
		name: "SignatureLengthInvalid",
		type: "error"
	},
	{
		inputs: [
		],
		name: "SignatureParameterSInvalid",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			}
		],
		name: "SignatureParameterVInvalid",
		type: "error"
	},
	{
		inputs: [
		],
		name: "StrategyHasNoSelector",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "strategyId",
				type: "uint256"
			}
		],
		name: "StrategyNotAvailable",
		type: "error"
	},
	{
		inputs: [
		],
		name: "StrategyNotUsed",
		type: "error"
	},
	{
		inputs: [
		],
		name: "StrategyProtocolFeeTooHigh",
		type: "error"
	},
	{
		inputs: [
		],
		name: "TransferAlreadyInProgress",
		type: "error"
	},
	{
		inputs: [
		],
		name: "TransferNotInProgress",
		type: "error"
	},
	{
		inputs: [
		],
		name: "WrongPotentialOwner",
		type: "error"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "affiliate",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "currency",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "affiliateFee",
				type: "uint256"
			}
		],
		name: "AffiliatePayment",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
		],
		name: "CancelOwnershipTransfer",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "currency",
				type: "address"
			},
			{
				indexed: false,
				internalType: "bool",
				name: "isAllowed",
				type: "bool"
			}
		],
		name: "CurrencyStatusUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
		],
		name: "InitiateOwnershipRenouncement",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "previousOwner",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "potentialOwner",
				type: "address"
			}
		],
		name: "InitiateOwnershipTransfer",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "affiliateController",
				type: "address"
			}
		],
		name: "NewAffiliateController",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "bool",
				name: "isActive",
				type: "bool"
			}
		],
		name: "NewAffiliateProgramStatus",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "affiliate",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "rate",
				type: "uint256"
			}
		],
		name: "NewAffiliateRate",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "user",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "bidNonce",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "askNonce",
				type: "uint256"
			}
		],
		name: "NewBidAskNonces",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "creatorFeeManager",
				type: "address"
			}
		],
		name: "NewCreatorFeeManager",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
		],
		name: "NewDomainSeparator",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "gasLimitETHTransfer",
				type: "uint256"
			}
		],
		name: "NewGasLimitETHTransfer",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "maxCreatorFeeBp",
				type: "uint256"
			}
		],
		name: "NewMaxCreatorFeeBp",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "newOwner",
				type: "address"
			}
		],
		name: "NewOwner",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "protocolFeeRecipient",
				type: "address"
			}
		],
		name: "NewProtocolFeeRecipient",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "strategyId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint16",
				name: "standardProtocolFeeBp",
				type: "uint16"
			},
			{
				indexed: false,
				internalType: "uint16",
				name: "minTotalFeeBp",
				type: "uint16"
			},
			{
				indexed: false,
				internalType: "uint16",
				name: "maxProtocolFeeBp",
				type: "uint16"
			},
			{
				indexed: false,
				internalType: "bytes4",
				name: "selector",
				type: "bytes4"
			},
			{
				indexed: false,
				internalType: "bool",
				name: "isMakerBid",
				type: "bool"
			},
			{
				indexed: false,
				internalType: "address",
				name: "implementation",
				type: "address"
			}
		],
		name: "NewStrategy",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "user",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256[]",
				name: "orderNonces",
				type: "uint256[]"
			}
		],
		name: "OrderNoncesCancelled",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "strategyId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "bool",
				name: "isActive",
				type: "bool"
			},
			{
				indexed: false,
				internalType: "uint16",
				name: "standardProtocolFeeBp",
				type: "uint16"
			},
			{
				indexed: false,
				internalType: "uint16",
				name: "minTotalFeeBp",
				type: "uint16"
			}
		],
		name: "StrategyUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "user",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256[]",
				name: "subsetNonces",
				type: "uint256[]"
			}
		],
		name: "SubsetNoncesCancelled",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				components: [
					{
						internalType: "bytes32",
						name: "orderHash",
						type: "bytes32"
					},
					{
						internalType: "uint256",
						name: "orderNonce",
						type: "uint256"
					},
					{
						internalType: "bool",
						name: "isNonceInvalidated",
						type: "bool"
					}
				],
				indexed: false,
				internalType: "struct ILooksRareProtocol.NonceInvalidationParameters",
				name: "nonceInvalidationParameters",
				type: "tuple"
			},
			{
				indexed: false,
				internalType: "address",
				name: "askUser",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "bidUser",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "strategyId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "address",
				name: "currency",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "collection",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256[]",
				name: "itemIds",
				type: "uint256[]"
			},
			{
				indexed: false,
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			},
			{
				indexed: false,
				internalType: "address[2]",
				name: "feeRecipients",
				type: "address[2]"
			},
			{
				indexed: false,
				internalType: "uint256[3]",
				name: "feeAmounts",
				type: "uint256[3]"
			}
		],
		name: "TakerAsk",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				components: [
					{
						internalType: "bytes32",
						name: "orderHash",
						type: "bytes32"
					},
					{
						internalType: "uint256",
						name: "orderNonce",
						type: "uint256"
					},
					{
						internalType: "bool",
						name: "isNonceInvalidated",
						type: "bool"
					}
				],
				indexed: false,
				internalType: "struct ILooksRareProtocol.NonceInvalidationParameters",
				name: "nonceInvalidationParameters",
				type: "tuple"
			},
			{
				indexed: false,
				internalType: "address",
				name: "bidUser",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "bidRecipient",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "strategyId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "address",
				name: "currency",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "collection",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256[]",
				name: "itemIds",
				type: "uint256[]"
			},
			{
				indexed: false,
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			},
			{
				indexed: false,
				internalType: "address[2]",
				name: "feeRecipients",
				type: "address[2]"
			},
			{
				indexed: false,
				internalType: "uint256[3]",
				name: "feeAmounts",
				type: "uint256[3]"
			}
		],
		name: "TakerBid",
		type: "event"
	},
	{
		inputs: [
		],
		name: "MAGIC_VALUE_ORDER_NONCE_EXECUTED",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "WETH",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint16",
				name: "standardProtocolFeeBp",
				type: "uint16"
			},
			{
				internalType: "uint16",
				name: "minTotalFeeBp",
				type: "uint16"
			},
			{
				internalType: "uint16",
				name: "maxProtocolFeeBp",
				type: "uint16"
			},
			{
				internalType: "bytes4",
				name: "selector",
				type: "bytes4"
			},
			{
				internalType: "bool",
				name: "isMakerBid",
				type: "bool"
			},
			{
				internalType: "address",
				name: "implementation",
				type: "address"
			}
		],
		name: "addStrategy",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "affiliateController",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "affiliateRates",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256[]",
				name: "orderNonces",
				type: "uint256[]"
			}
		],
		name: "cancelOrderNonces",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "cancelOwnershipTransfer",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256[]",
				name: "subsetNonces",
				type: "uint256[]"
			}
		],
		name: "cancelSubsetNonces",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "chainId",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "confirmOwnershipRenouncement",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "confirmOwnershipTransfer",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "creatorFeeManager",
		outputs: [
			{
				internalType: "contract ICreatorFeeManager",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "domainSeparator",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "recipient",
						type: "address"
					},
					{
						internalType: "bytes",
						name: "additionalParameters",
						type: "bytes"
					}
				],
				internalType: "struct OrderStructs.Taker[]",
				name: "takerBids",
				type: "tuple[]"
			},
			{
				components: [
					{
						internalType: "enum QuoteType",
						name: "quoteType",
						type: "uint8"
					},
					{
						internalType: "uint256",
						name: "globalNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "subsetNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "orderNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "strategyId",
						type: "uint256"
					},
					{
						internalType: "enum CollectionType",
						name: "collectionType",
						type: "uint8"
					},
					{
						internalType: "address",
						name: "collection",
						type: "address"
					},
					{
						internalType: "address",
						name: "currency",
						type: "address"
					},
					{
						internalType: "address",
						name: "signer",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "startTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "endTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "price",
						type: "uint256"
					},
					{
						internalType: "uint256[]",
						name: "itemIds",
						type: "uint256[]"
					},
					{
						internalType: "uint256[]",
						name: "amounts",
						type: "uint256[]"
					},
					{
						internalType: "bytes",
						name: "additionalParameters",
						type: "bytes"
					}
				],
				internalType: "struct OrderStructs.Maker[]",
				name: "makerAsks",
				type: "tuple[]"
			},
			{
				internalType: "bytes[]",
				name: "makerSignatures",
				type: "bytes[]"
			},
			{
				components: [
					{
						internalType: "bytes32",
						name: "root",
						type: "bytes32"
					},
					{
						components: [
							{
								internalType: "bytes32",
								name: "value",
								type: "bytes32"
							},
							{
								internalType: "enum OrderStructs.MerkleTreeNodePosition",
								name: "position",
								type: "uint8"
							}
						],
						internalType: "struct OrderStructs.MerkleTreeNode[]",
						name: "proof",
						type: "tuple[]"
					}
				],
				internalType: "struct OrderStructs.MerkleTree[]",
				name: "merkleTrees",
				type: "tuple[]"
			},
			{
				internalType: "address",
				name: "affiliate",
				type: "address"
			},
			{
				internalType: "bool",
				name: "isAtomic",
				type: "bool"
			}
		],
		name: "executeMultipleTakerBids",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "recipient",
						type: "address"
					},
					{
						internalType: "bytes",
						name: "additionalParameters",
						type: "bytes"
					}
				],
				internalType: "struct OrderStructs.Taker",
				name: "takerAsk",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "enum QuoteType",
						name: "quoteType",
						type: "uint8"
					},
					{
						internalType: "uint256",
						name: "globalNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "subsetNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "orderNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "strategyId",
						type: "uint256"
					},
					{
						internalType: "enum CollectionType",
						name: "collectionType",
						type: "uint8"
					},
					{
						internalType: "address",
						name: "collection",
						type: "address"
					},
					{
						internalType: "address",
						name: "currency",
						type: "address"
					},
					{
						internalType: "address",
						name: "signer",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "startTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "endTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "price",
						type: "uint256"
					},
					{
						internalType: "uint256[]",
						name: "itemIds",
						type: "uint256[]"
					},
					{
						internalType: "uint256[]",
						name: "amounts",
						type: "uint256[]"
					},
					{
						internalType: "bytes",
						name: "additionalParameters",
						type: "bytes"
					}
				],
				internalType: "struct OrderStructs.Maker",
				name: "makerBid",
				type: "tuple"
			},
			{
				internalType: "bytes",
				name: "makerSignature",
				type: "bytes"
			},
			{
				components: [
					{
						internalType: "bytes32",
						name: "root",
						type: "bytes32"
					},
					{
						components: [
							{
								internalType: "bytes32",
								name: "value",
								type: "bytes32"
							},
							{
								internalType: "enum OrderStructs.MerkleTreeNodePosition",
								name: "position",
								type: "uint8"
							}
						],
						internalType: "struct OrderStructs.MerkleTreeNode[]",
						name: "proof",
						type: "tuple[]"
					}
				],
				internalType: "struct OrderStructs.MerkleTree",
				name: "merkleTree",
				type: "tuple"
			},
			{
				internalType: "address",
				name: "affiliate",
				type: "address"
			}
		],
		name: "executeTakerAsk",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "recipient",
						type: "address"
					},
					{
						internalType: "bytes",
						name: "additionalParameters",
						type: "bytes"
					}
				],
				internalType: "struct OrderStructs.Taker",
				name: "takerBid",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "enum QuoteType",
						name: "quoteType",
						type: "uint8"
					},
					{
						internalType: "uint256",
						name: "globalNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "subsetNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "orderNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "strategyId",
						type: "uint256"
					},
					{
						internalType: "enum CollectionType",
						name: "collectionType",
						type: "uint8"
					},
					{
						internalType: "address",
						name: "collection",
						type: "address"
					},
					{
						internalType: "address",
						name: "currency",
						type: "address"
					},
					{
						internalType: "address",
						name: "signer",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "startTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "endTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "price",
						type: "uint256"
					},
					{
						internalType: "uint256[]",
						name: "itemIds",
						type: "uint256[]"
					},
					{
						internalType: "uint256[]",
						name: "amounts",
						type: "uint256[]"
					},
					{
						internalType: "bytes",
						name: "additionalParameters",
						type: "bytes"
					}
				],
				internalType: "struct OrderStructs.Maker",
				name: "makerAsk",
				type: "tuple"
			},
			{
				internalType: "bytes",
				name: "makerSignature",
				type: "bytes"
			},
			{
				components: [
					{
						internalType: "bytes32",
						name: "root",
						type: "bytes32"
					},
					{
						components: [
							{
								internalType: "bytes32",
								name: "value",
								type: "bytes32"
							},
							{
								internalType: "enum OrderStructs.MerkleTreeNodePosition",
								name: "position",
								type: "uint8"
							}
						],
						internalType: "struct OrderStructs.MerkleTreeNode[]",
						name: "proof",
						type: "tuple[]"
					}
				],
				internalType: "struct OrderStructs.MerkleTree",
				name: "merkleTree",
				type: "tuple"
			},
			{
				internalType: "address",
				name: "affiliate",
				type: "address"
			}
		],
		name: "executeTakerBid",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "root",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "proofLength",
				type: "uint256"
			}
		],
		name: "hashBatchOrder",
		outputs: [
			{
				internalType: "bytes32",
				name: "batchOrderHash",
				type: "bytes32"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bool",
				name: "bid",
				type: "bool"
			},
			{
				internalType: "bool",
				name: "ask",
				type: "bool"
			}
		],
		name: "incrementBidAskNonces",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "initiateOwnershipRenouncement",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "newPotentialOwner",
				type: "address"
			}
		],
		name: "initiateOwnershipTransfer",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "isAffiliateProgramActive",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "isCurrencyAllowed",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "maxCreatorFeeBp",
		outputs: [
			{
				internalType: "uint16",
				name: "",
				type: "uint16"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "owner",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "ownershipStatus",
		outputs: [
			{
				internalType: "enum IOwnableTwoSteps.Status",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "potentialOwner",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "protocolFeeRecipient",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "recipient",
						type: "address"
					},
					{
						internalType: "bytes",
						name: "additionalParameters",
						type: "bytes"
					}
				],
				internalType: "struct OrderStructs.Taker",
				name: "takerBid",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "enum QuoteType",
						name: "quoteType",
						type: "uint8"
					},
					{
						internalType: "uint256",
						name: "globalNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "subsetNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "orderNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "strategyId",
						type: "uint256"
					},
					{
						internalType: "enum CollectionType",
						name: "collectionType",
						type: "uint8"
					},
					{
						internalType: "address",
						name: "collection",
						type: "address"
					},
					{
						internalType: "address",
						name: "currency",
						type: "address"
					},
					{
						internalType: "address",
						name: "signer",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "startTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "endTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "price",
						type: "uint256"
					},
					{
						internalType: "uint256[]",
						name: "itemIds",
						type: "uint256[]"
					},
					{
						internalType: "uint256[]",
						name: "amounts",
						type: "uint256[]"
					},
					{
						internalType: "bytes",
						name: "additionalParameters",
						type: "bytes"
					}
				],
				internalType: "struct OrderStructs.Maker",
				name: "makerAsk",
				type: "tuple"
			},
			{
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				internalType: "bytes32",
				name: "orderHash",
				type: "bytes32"
			}
		],
		name: "restrictedExecuteTakerBid",
		outputs: [
			{
				internalType: "uint256",
				name: "protocolFeeAmount",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "strategyInfo",
		outputs: [
			{
				internalType: "bool",
				name: "isActive",
				type: "bool"
			},
			{
				internalType: "uint16",
				name: "standardProtocolFeeBp",
				type: "uint16"
			},
			{
				internalType: "uint16",
				name: "minTotalFeeBp",
				type: "uint16"
			},
			{
				internalType: "uint16",
				name: "maxProtocolFeeBp",
				type: "uint16"
			},
			{
				internalType: "bytes4",
				name: "selector",
				type: "bytes4"
			},
			{
				internalType: "bool",
				name: "isMakerBid",
				type: "bool"
			},
			{
				internalType: "address",
				name: "implementation",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "transferManager",
		outputs: [
			{
				internalType: "contract TransferManager",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "newAffiliateController",
				type: "address"
			}
		],
		name: "updateAffiliateController",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bool",
				name: "isActive",
				type: "bool"
			}
		],
		name: "updateAffiliateProgramStatus",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "affiliate",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "bp",
				type: "uint256"
			}
		],
		name: "updateAffiliateRate",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "newCreatorFeeManager",
				type: "address"
			}
		],
		name: "updateCreatorFeeManager",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "currency",
				type: "address"
			},
			{
				internalType: "bool",
				name: "isAllowed",
				type: "bool"
			}
		],
		name: "updateCurrencyStatus",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "updateDomainSeparator",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "newGasLimitETHTransfer",
				type: "uint256"
			}
		],
		name: "updateETHGasLimitForTransfer",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint16",
				name: "newMaxCreatorFeeBp",
				type: "uint16"
			}
		],
		name: "updateMaxCreatorFeeBp",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "newProtocolFeeRecipient",
				type: "address"
			}
		],
		name: "updateProtocolFeeRecipient",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "strategyId",
				type: "uint256"
			},
			{
				internalType: "bool",
				name: "isActive",
				type: "bool"
			},
			{
				internalType: "uint16",
				name: "newStandardProtocolFee",
				type: "uint16"
			},
			{
				internalType: "uint16",
				name: "newMinTotalFee",
				type: "uint16"
			}
		],
		name: "updateStrategy",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "userBidAskNonces",
		outputs: [
			{
				internalType: "uint256",
				name: "bidNonce",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "askNonce",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "userOrderNonce",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "userSubsetNonce",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	}
];

const executeTakerBid = (signer, address, taker, maker, makerSignature, merkleTree, affiliate, overrides) => {
    const overridesWithValue = Object.assign(Object.assign({}, overrides), (maker.currency === constants.AddressZero && { value: maker.price }));
    const contract = new Contract(address, abi$2, signer);
    return {
        call: (additionalOverrides) => contract.executeTakerBid(taker, maker, makerSignature, merkleTree, affiliate, Object.assign(Object.assign({}, overridesWithValue), additionalOverrides)),
        estimateGas: (additionalOverrides) => contract.estimateGas.executeTakerBid(taker, maker, makerSignature, merkleTree, affiliate, Object.assign(Object.assign({}, overridesWithValue), additionalOverrides)),
        callStatic: (additionalOverrides) => contract.callStatic.executeTakerBid(taker, maker, makerSignature, merkleTree, affiliate, Object.assign(Object.assign({}, overridesWithValue), additionalOverrides)),
    };
};
const executeTakerAsk = (signer, address, taker, maker, makerSignature, merkleTree, affiliate, overrides) => {
    const contract = new Contract(address, abi$2, signer);
    return {
        call: (additionalOverrides) => contract.executeTakerAsk(taker, maker, makerSignature, merkleTree, affiliate, Object.assign(Object.assign({}, overrides), additionalOverrides)),
        estimateGas: (additionalOverrides) => contract.estimateGas.executeTakerAsk(taker, maker, makerSignature, merkleTree, affiliate, Object.assign(Object.assign({}, overrides), additionalOverrides)),
        callStatic: (additionalOverrides) => contract.callStatic.executeTakerAsk(taker, maker, makerSignature, merkleTree, affiliate, Object.assign(Object.assign({}, overrides), additionalOverrides)),
    };
};
const executeMultipleTakerBids = (signer, address, taker, maker, makerSignature, isAtomic, merkleTree, affiliate, overrides) => {
    const value = maker.reduce((acc, order) => (order.currency === constants.AddressZero ? acc.add(order.price) : acc), BigNumber.from(0));
    const overridesWithValue = Object.assign(Object.assign({}, overrides), (value.gt(0) && { value }));
    const contract = new Contract(address, abi$2, signer);
    return {
        call: (additionalOverrides) => contract.executeMultipleTakerBids(taker, maker, makerSignature, merkleTree, affiliate, isAtomic, Object.assign(Object.assign({}, overridesWithValue), additionalOverrides)),
        estimateGas: (additionalOverrides) => contract.estimateGas.executeMultipleTakerBids(taker, maker, makerSignature, merkleTree, affiliate, isAtomic, Object.assign(Object.assign({}, overridesWithValue), additionalOverrides)),
        callStatic: (additionalOverrides) => contract.callStatic.executeMultipleTakerBids(taker, maker, makerSignature, merkleTree, affiliate, isAtomic, Object.assign(Object.assign({}, overridesWithValue), additionalOverrides)),
    };
};

var exchange = /*#__PURE__*/Object.freeze({
  __proto__: null,
  executeMultipleTakerBids: executeMultipleTakerBids,
  executeTakerAsk: executeTakerAsk,
  executeTakerBid: executeTakerBid
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

const viewUserBidAskNonces = (signerOrProvider, address, account, overrides) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = new Contract(address, abi$2, signerOrProvider);
    const nonces = yield contract.userBidAskNonces(account, Object.assign({}, overrides));
    return { bidNonce: nonces[0], askNonce: nonces[1] };
});
const cancelOrderNonces = (signer, address, nonces, overrides) => {
    const contract = new Contract(address, abi$2, signer);
    return {
        call: (additionalOverrides) => contract.cancelOrderNonces(nonces, Object.assign(Object.assign({}, overrides), additionalOverrides)),
        estimateGas: (additionalOverrides) => contract.estimateGas.cancelOrderNonces(nonces, Object.assign(Object.assign({}, overrides), additionalOverrides)),
        callStatic: (additionalOverrides) => contract.callStatic.cancelOrderNonces(nonces, Object.assign(Object.assign({}, overrides), additionalOverrides)),
    };
};
const cancelSubsetNonces = (signer, address, nonces, overrides) => {
    const contract = new Contract(address, abi$2, signer);
    return {
        call: (additionalOverrides) => contract.cancelSubsetNonces(nonces, Object.assign(Object.assign({}, overrides), additionalOverrides)),
        estimateGas: (additionalOverrides) => contract.estimateGas.cancelSubsetNonces(nonces, Object.assign(Object.assign({}, overrides), additionalOverrides)),
        callStatic: (additionalOverrides) => contract.callStatic.cancelSubsetNonces(nonces, Object.assign(Object.assign({}, overrides), additionalOverrides)),
    };
};
const incrementBidAskNonces = (signer, address, bid, ask, overrides) => {
    const contract = new Contract(address, abi$2, signer);
    return {
        call: (additionalOverrides) => contract.incrementBidAskNonces(bid, ask, Object.assign(Object.assign({}, overrides), additionalOverrides)),
        estimateGas: (additionalOverrides) => contract.estimateGas.incrementBidAskNonces(bid, ask, Object.assign(Object.assign({}, overrides), additionalOverrides)),
        callStatic: (additionalOverrides) => contract.callStatic.incrementBidAskNonces(bid, ask, Object.assign(Object.assign({}, overrides), additionalOverrides)),
    };
};

var nonces = /*#__PURE__*/Object.freeze({
  __proto__: null,
  cancelOrderNonces: cancelOrderNonces,
  cancelSubsetNonces: cancelSubsetNonces,
  incrementBidAskNonces: incrementBidAskNonces,
  viewUserBidAskNonces: viewUserBidAskNonces
});

var abi$1 = [
	{
		inputs: [
			{
				internalType: "address",
				name: "_owner",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
		],
		name: "AmountInvalid",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ERC1155SafeBatchTransferFromFail",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ERC1155SafeTransferFromFail",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ERC721TransferFromFail",
		type: "error"
	},
	{
		inputs: [
		],
		name: "LengthsInvalid",
		type: "error"
	},
	{
		inputs: [
		],
		name: "NoOngoingTransferInProgress",
		type: "error"
	},
	{
		inputs: [
		],
		name: "NotAContract",
		type: "error"
	},
	{
		inputs: [
		],
		name: "NotOwner",
		type: "error"
	},
	{
		inputs: [
		],
		name: "OperatorAlreadyAllowed",
		type: "error"
	},
	{
		inputs: [
		],
		name: "OperatorAlreadyApprovedByUser",
		type: "error"
	},
	{
		inputs: [
		],
		name: "OperatorNotAllowed",
		type: "error"
	},
	{
		inputs: [
		],
		name: "OperatorNotApprovedByUser",
		type: "error"
	},
	{
		inputs: [
		],
		name: "RenouncementNotInProgress",
		type: "error"
	},
	{
		inputs: [
		],
		name: "TransferAlreadyInProgress",
		type: "error"
	},
	{
		inputs: [
		],
		name: "TransferCallerInvalid",
		type: "error"
	},
	{
		inputs: [
		],
		name: "TransferNotInProgress",
		type: "error"
	},
	{
		inputs: [
		],
		name: "WrongPotentialOwner",
		type: "error"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "user",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address[]",
				name: "operators",
				type: "address[]"
			}
		],
		name: "ApprovalsGranted",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "user",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address[]",
				name: "operators",
				type: "address[]"
			}
		],
		name: "ApprovalsRemoved",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
		],
		name: "CancelOwnershipTransfer",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
		],
		name: "InitiateOwnershipRenouncement",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "previousOwner",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "potentialOwner",
				type: "address"
			}
		],
		name: "InitiateOwnershipTransfer",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "newOwner",
				type: "address"
			}
		],
		name: "NewOwner",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "operator",
				type: "address"
			}
		],
		name: "OperatorAllowed",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "operator",
				type: "address"
			}
		],
		name: "OperatorRemoved",
		type: "event"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "operator",
				type: "address"
			}
		],
		name: "allowOperator",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "cancelOwnershipTransfer",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "confirmOwnershipRenouncement",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "confirmOwnershipTransfer",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address[]",
				name: "operators",
				type: "address[]"
			}
		],
		name: "grantApprovals",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "hasUserApprovedOperator",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "initiateOwnershipRenouncement",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "newPotentialOwner",
				type: "address"
			}
		],
		name: "initiateOwnershipTransfer",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "isOperatorAllowed",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "owner",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "ownershipStatus",
		outputs: [
			{
				internalType: "enum IOwnableTwoSteps.Status",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "potentialOwner",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "operator",
				type: "address"
			}
		],
		name: "removeOperator",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address[]",
				name: "operators",
				type: "address[]"
			}
		],
		name: "revokeApprovals",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "collection",
						type: "address"
					},
					{
						internalType: "enum CollectionType",
						name: "collectionType",
						type: "uint8"
					},
					{
						internalType: "uint256[]",
						name: "itemIds",
						type: "uint256[]"
					},
					{
						internalType: "uint256[]",
						name: "amounts",
						type: "uint256[]"
					}
				],
				internalType: "struct ITransferManager.BatchTransferItem[]",
				name: "items",
				type: "tuple[]"
			},
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			}
		],
		name: "transferBatchItemsAcrossCollections",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "collection",
				type: "address"
			},
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256[]",
				name: "itemIds",
				type: "uint256[]"
			},
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		name: "transferItemsERC1155",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "collection",
				type: "address"
			},
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256[]",
				name: "itemIds",
				type: "uint256[]"
			},
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		name: "transferItemsERC721",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

const hasUserApprovedOperator = (signerOrProvider, address, user, operator, overrides) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = new Contract(address, abi$1, signerOrProvider);
    const hasApproved = yield contract.hasUserApprovedOperator(user, operator, Object.assign({}, overrides));
    return hasApproved;
});
const grantApprovals = (signer, address, operators, overrides) => {
    const contract = new Contract(address, abi$1, signer);
    return {
        call: (additionalOverrides) => contract.grantApprovals(operators, Object.assign(Object.assign({}, overrides), additionalOverrides)),
        estimateGas: (additionalOverrides) => contract.estimateGas.grantApprovals(operators, Object.assign(Object.assign({}, overrides), additionalOverrides)),
        callStatic: (additionalOverrides) => contract.callStatic.grantApprovals(operators, Object.assign(Object.assign({}, overrides), additionalOverrides)),
    };
};
const revokeApprovals = (signer, address, operators, overrides) => {
    const contract = new Contract(address, abi$1, signer);
    return {
        call: (additionalOverrides) => contract.revokeApprovals(operators, Object.assign(Object.assign({}, overrides), additionalOverrides)),
        estimateGas: (additionalOverrides) => contract.estimateGas.revokeApprovals(operators, Object.assign(Object.assign({}, overrides), additionalOverrides)),
        callStatic: (additionalOverrides) => contract.callStatic.revokeApprovals(operators, Object.assign(Object.assign({}, overrides), additionalOverrides)),
    };
};
const transferBatchItemsAcrossCollections = (signer, address, items, from, to, overrides) => {
    const contract = new Contract(address, abi$1, signer);
    return {
        call: (additionalOverrides) => contract.transferBatchItemsAcrossCollections(items, from, to, Object.assign(Object.assign({}, overrides), additionalOverrides)),
        estimateGas: (additionalOverrides) => contract.estimateGas.transferBatchItemsAcrossCollections(items, from, to, Object.assign(Object.assign({}, overrides), additionalOverrides)),
        callStatic: (additionalOverrides) => contract.callStatic.transferBatchItemsAcrossCollections(items, from, to, Object.assign(Object.assign({}, overrides), additionalOverrides)),
    };
};

var transferManager = /*#__PURE__*/Object.freeze({
  __proto__: null,
  grantApprovals: grantApprovals,
  hasUserApprovedOperator: hasUserApprovedOperator,
  revokeApprovals: revokeApprovals,
  transferBatchItemsAcrossCollections: transferBatchItemsAcrossCollections
});

var abi = [
	{
		inputs: [
			{
				internalType: "address",
				name: "_looksRareProtocol",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
		],
		name: "CRITERIA_GROUPS",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "ERC1155_INTERFACE_ID",
		outputs: [
			{
				internalType: "bytes4",
				name: "",
				type: "bytes4"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "ERC721_INTERFACE_ID_1",
		outputs: [
			{
				internalType: "bytes4",
				name: "",
				type: "bytes4"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "ERC721_INTERFACE_ID_2",
		outputs: [
			{
				internalType: "bytes4",
				name: "",
				type: "bytes4"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "MAGIC_VALUE_ORDER_NONCE_EXECUTED",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "enum QuoteType",
						name: "quoteType",
						type: "uint8"
					},
					{
						internalType: "uint256",
						name: "globalNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "subsetNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "orderNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "strategyId",
						type: "uint256"
					},
					{
						internalType: "enum CollectionType",
						name: "collectionType",
						type: "uint8"
					},
					{
						internalType: "address",
						name: "collection",
						type: "address"
					},
					{
						internalType: "address",
						name: "currency",
						type: "address"
					},
					{
						internalType: "address",
						name: "signer",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "startTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "endTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "price",
						type: "uint256"
					},
					{
						internalType: "uint256[]",
						name: "itemIds",
						type: "uint256[]"
					},
					{
						internalType: "uint256[]",
						name: "amounts",
						type: "uint256[]"
					},
					{
						internalType: "bytes",
						name: "additionalParameters",
						type: "bytes"
					}
				],
				internalType: "struct OrderStructs.Maker",
				name: "makerOrder",
				type: "tuple"
			},
			{
				internalType: "bytes",
				name: "signature",
				type: "bytes"
			},
			{
				components: [
					{
						internalType: "bytes32",
						name: "root",
						type: "bytes32"
					},
					{
						components: [
							{
								internalType: "bytes32",
								name: "value",
								type: "bytes32"
							},
							{
								internalType: "enum OrderStructs.MerkleTreeNodePosition",
								name: "position",
								type: "uint8"
							}
						],
						internalType: "struct OrderStructs.MerkleTreeNode[]",
						name: "proof",
						type: "tuple[]"
					}
				],
				internalType: "struct OrderStructs.MerkleTree",
				name: "merkleTree",
				type: "tuple"
			}
		],
		name: "checkMakerOrderValidity",
		outputs: [
			{
				internalType: "uint256[9]",
				name: "validationCodes",
				type: "uint256[9]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "enum QuoteType",
						name: "quoteType",
						type: "uint8"
					},
					{
						internalType: "uint256",
						name: "globalNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "subsetNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "orderNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "strategyId",
						type: "uint256"
					},
					{
						internalType: "enum CollectionType",
						name: "collectionType",
						type: "uint8"
					},
					{
						internalType: "address",
						name: "collection",
						type: "address"
					},
					{
						internalType: "address",
						name: "currency",
						type: "address"
					},
					{
						internalType: "address",
						name: "signer",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "startTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "endTime",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "price",
						type: "uint256"
					},
					{
						internalType: "uint256[]",
						name: "itemIds",
						type: "uint256[]"
					},
					{
						internalType: "uint256[]",
						name: "amounts",
						type: "uint256[]"
					},
					{
						internalType: "bytes",
						name: "additionalParameters",
						type: "bytes"
					}
				],
				internalType: "struct OrderStructs.Maker[]",
				name: "makerOrders",
				type: "tuple[]"
			},
			{
				internalType: "bytes[]",
				name: "signatures",
				type: "bytes[]"
			},
			{
				components: [
					{
						internalType: "bytes32",
						name: "root",
						type: "bytes32"
					},
					{
						components: [
							{
								internalType: "bytes32",
								name: "value",
								type: "bytes32"
							},
							{
								internalType: "enum OrderStructs.MerkleTreeNodePosition",
								name: "position",
								type: "uint8"
							}
						],
						internalType: "struct OrderStructs.MerkleTreeNode[]",
						name: "proof",
						type: "tuple[]"
					}
				],
				internalType: "struct OrderStructs.MerkleTree[]",
				name: "merkleTrees",
				type: "tuple[]"
			}
		],
		name: "checkMultipleMakerOrderValidities",
		outputs: [
			{
				internalType: "uint256[9][]",
				name: "validationCodes",
				type: "uint256[9][]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "creatorFeeManager",
		outputs: [
			{
				internalType: "contract ICreatorFeeManager",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "deriveProtocolParameters",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "domainSeparator",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "looksRareProtocol",
		outputs: [
			{
				internalType: "contract LooksRareProtocol",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "maxCreatorFeeBp",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "transferManager",
		outputs: [
			{
				internalType: "contract TransferManager",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	}
];

const verifyMakerOrders = (signerOrProvider, address, makerOrders, signatures, merkleTrees, overrides) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = new Contract(address, abi, signerOrProvider);
    const orders = yield contract.checkMultipleMakerOrderValidities(makerOrders, signatures, merkleTrees, Object.assign({}, overrides));
    return orders.map((order) => order.map((code) => code.toNumber()));
});

var orderValidator = /*#__PURE__*/Object.freeze({
  __proto__: null,
  verifyMakerOrders: verifyMakerOrders
});

const strategyInfo = (signerOrProvider, address, strategyId, overrides) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = new Contract(address, abi$2, signerOrProvider);
    const strategy = yield contract.strategyInfo(strategyId, Object.assign({}, overrides));
    return {
        isActive: strategy.isActive,
        standardProtocolFeeBp: strategy.standardProtocolFeeBp,
        minTotalFeeBp: strategy.minTotalFeeBp,
        maxProtocolFeeBp: strategy.maxProtocolFeeBp,
    };
});

var strategies = /*#__PURE__*/Object.freeze({
  __proto__: null,
  strategyInfo: strategyInfo
});

/** List of supported chains */
var ChainId;
(function (ChainId) {
    ChainId[ChainId["MAINNET"] = 1] = "MAINNET";
    ChainId[ChainId["GOERLI"] = 5] = "GOERLI";
    ChainId[ChainId["SEPOLIA"] = 11155111] = "SEPOLIA";
    ChainId[ChainId["HARDHAT"] = 31337] = "HARDHAT";
    ChainId[ChainId["ARB_MAINNET"] = 42161] = "ARB_MAINNET";
    ChainId[ChainId["ARB_SEPOLIA"] = 421614] = "ARB_SEPOLIA";
    ChainId[ChainId["BASE_MAINNET"] = 8453] = "BASE_MAINNET";
    ChainId[ChainId["BASE_SEPOLIA"] = 84532] = "BASE_SEPOLIA";
    ChainId[ChainId["BLAST_SEPOLIA"] = 168587773] = "BLAST_SEPOLIA";
    ChainId[ChainId["BLAST_MAINNET"] = 81457] = "BLAST_MAINNET";
})(ChainId || (ChainId = {}));
/** List of collection types supported by the protocol */
var CollectionType;
(function (CollectionType) {
    CollectionType[CollectionType["ERC721"] = 0] = "ERC721";
    CollectionType[CollectionType["ERC1155"] = 1] = "ERC1155";
})(CollectionType || (CollectionType = {}));
/** List of trading strategies */
var StrategyType;
(function (StrategyType) {
    StrategyType[StrategyType["standard"] = 0] = "standard";
    StrategyType[StrategyType["collection"] = 1] = "collection";
    StrategyType[StrategyType["collectionWithMerkleTree"] = 2] = "collectionWithMerkleTree";
})(StrategyType || (StrategyType = {}));
/** Type for maker order */
var QuoteType;
(function (QuoteType) {
    QuoteType[QuoteType["Bid"] = 0] = "Bid";
    QuoteType[QuoteType["Ask"] = 1] = "Ask";
})(QuoteType || (QuoteType = {}));
/** Merkle tree node position (needed by the SC) */
var MerkleTreeNodePosition;
(function (MerkleTreeNodePosition) {
    MerkleTreeNodePosition[MerkleTreeNodePosition["Left"] = 0] = "Left";
    MerkleTreeNodePosition[MerkleTreeNodePosition["Right"] = 1] = "Right";
})(MerkleTreeNodePosition || (MerkleTreeNodePosition = {}));
/** Error errors returned by the order validator contract */
var OrderValidatorCode;
(function (OrderValidatorCode) {
    // 0. No error
    OrderValidatorCode[OrderValidatorCode["ORDER_EXPECTED_TO_BE_VALID"] = 0] = "ORDER_EXPECTED_TO_BE_VALID";
    // 1. Strategy & currency-related errors
    OrderValidatorCode[OrderValidatorCode["CURRENCY_NOT_ALLOWED"] = 101] = "CURRENCY_NOT_ALLOWED";
    OrderValidatorCode[OrderValidatorCode["STRATEGY_NOT_IMPLEMENTED"] = 111] = "STRATEGY_NOT_IMPLEMENTED";
    OrderValidatorCode[OrderValidatorCode["STRATEGY_INVALID_QUOTE_TYPE"] = 112] = "STRATEGY_INVALID_QUOTE_TYPE";
    OrderValidatorCode[OrderValidatorCode["STRATEGY_NOT_ACTIVE"] = 113] = "STRATEGY_NOT_ACTIVE";
    // 2. Maker order struct-related errors
    OrderValidatorCode[OrderValidatorCode["MAKER_ORDER_INVALID_STANDARD_SALE"] = 201] = "MAKER_ORDER_INVALID_STANDARD_SALE";
    OrderValidatorCode[OrderValidatorCode["MAKER_ORDER_PERMANENTLY_INVALID_NON_STANDARD_SALE"] = 211] = "MAKER_ORDER_PERMANENTLY_INVALID_NON_STANDARD_SALE";
    OrderValidatorCode[OrderValidatorCode["MAKER_ORDER_INVALID_CURRENCY_NON_STANDARD_SALE"] = 212] = "MAKER_ORDER_INVALID_CURRENCY_NON_STANDARD_SALE";
    OrderValidatorCode[OrderValidatorCode["MAKER_ORDER_TEMPORARILY_INVALID_NON_STANDARD_SALE"] = 213] = "MAKER_ORDER_TEMPORARILY_INVALID_NON_STANDARD_SALE";
    // 3. Nonce-related errors
    OrderValidatorCode[OrderValidatorCode["USER_SUBSET_NONCE_CANCELLED"] = 301] = "USER_SUBSET_NONCE_CANCELLED";
    OrderValidatorCode[OrderValidatorCode["USER_ORDER_NONCE_EXECUTED_OR_CANCELLED"] = 311] = "USER_ORDER_NONCE_EXECUTED_OR_CANCELLED";
    OrderValidatorCode[OrderValidatorCode["USER_ORDER_NONCE_IN_EXECUTION_WITH_OTHER_HASH"] = 312] = "USER_ORDER_NONCE_IN_EXECUTION_WITH_OTHER_HASH";
    OrderValidatorCode[OrderValidatorCode["INVALID_USER_GLOBAL_BID_NONCE"] = 321] = "INVALID_USER_GLOBAL_BID_NONCE";
    OrderValidatorCode[OrderValidatorCode["INVALID_USER_GLOBAL_ASK_NONCE"] = 322] = "INVALID_USER_GLOBAL_ASK_NONCE";
    // 4. errors related to signatures (EOA, EIP-1271) and merkle tree computations
    OrderValidatorCode[OrderValidatorCode["ORDER_HASH_PROOF_NOT_IN_MERKLE_TREE"] = 401] = "ORDER_HASH_PROOF_NOT_IN_MERKLE_TREE";
    OrderValidatorCode[OrderValidatorCode["MERKLE_PROOF_PROOF_TOO_LARGE"] = 402] = "MERKLE_PROOF_PROOF_TOO_LARGE";
    OrderValidatorCode[OrderValidatorCode["INVALID_SIGNATURE_LENGTH"] = 411] = "INVALID_SIGNATURE_LENGTH";
    OrderValidatorCode[OrderValidatorCode["INVALID_S_PARAMETER_EOA"] = 412] = "INVALID_S_PARAMETER_EOA";
    OrderValidatorCode[OrderValidatorCode["INVALID_V_PARAMETER_EOA"] = 413] = "INVALID_V_PARAMETER_EOA";
    OrderValidatorCode[OrderValidatorCode["NULL_SIGNER_EOA"] = 414] = "NULL_SIGNER_EOA";
    OrderValidatorCode[OrderValidatorCode["INVALID_SIGNER_EOA"] = 415] = "INVALID_SIGNER_EOA";
    OrderValidatorCode[OrderValidatorCode["MISSING_IS_VALID_SIGNATURE_FUNCTION_EIP1271"] = 421] = "MISSING_IS_VALID_SIGNATURE_FUNCTION_EIP1271";
    OrderValidatorCode[OrderValidatorCode["SIGNATURE_INVALID_EIP1271"] = 422] = "SIGNATURE_INVALID_EIP1271";
    // 5. Timestamp-related errors
    OrderValidatorCode[OrderValidatorCode["START_TIME_GREATER_THAN_END_TIME"] = 501] = "START_TIME_GREATER_THAN_END_TIME";
    OrderValidatorCode[OrderValidatorCode["TOO_LATE_TO_EXECUTE_ORDER"] = 502] = "TOO_LATE_TO_EXECUTE_ORDER";
    OrderValidatorCode[OrderValidatorCode["TOO_EARLY_TO_EXECUTE_ORDER"] = 503] = "TOO_EARLY_TO_EXECUTE_ORDER";
    // 6. Transfer-related (ERC20, ERC721, ERC1155 tokens), including transfers and approvals, errors.
    OrderValidatorCode[OrderValidatorCode["SAME_ITEM_ID_IN_BUNDLE"] = 601] = "SAME_ITEM_ID_IN_BUNDLE";
    OrderValidatorCode[OrderValidatorCode["ERC20_BALANCE_INFERIOR_TO_PRICE"] = 611] = "ERC20_BALANCE_INFERIOR_TO_PRICE";
    OrderValidatorCode[OrderValidatorCode["ERC20_APPROVAL_INFERIOR_TO_PRICE"] = 612] = "ERC20_APPROVAL_INFERIOR_TO_PRICE";
    OrderValidatorCode[OrderValidatorCode["ERC721_ITEM_ID_DOES_NOT_EXIST"] = 621] = "ERC721_ITEM_ID_DOES_NOT_EXIST";
    OrderValidatorCode[OrderValidatorCode["ERC721_ITEM_ID_NOT_IN_BALANCE"] = 622] = "ERC721_ITEM_ID_NOT_IN_BALANCE";
    OrderValidatorCode[OrderValidatorCode["ERC721_NO_APPROVAL_FOR_ALL_OR_ITEM_ID"] = 623] = "ERC721_NO_APPROVAL_FOR_ALL_OR_ITEM_ID";
    OrderValidatorCode[OrderValidatorCode["ERC1155_BALANCE_OF_DOES_NOT_EXIST"] = 631] = "ERC1155_BALANCE_OF_DOES_NOT_EXIST";
    OrderValidatorCode[OrderValidatorCode["ERC1155_BALANCE_OF_ITEM_ID_INFERIOR_TO_AMOUNT"] = 632] = "ERC1155_BALANCE_OF_ITEM_ID_INFERIOR_TO_AMOUNT";
    OrderValidatorCode[OrderValidatorCode["ERC1155_IS_APPROVED_FOR_ALL_DOES_NOT_EXIST"] = 633] = "ERC1155_IS_APPROVED_FOR_ALL_DOES_NOT_EXIST";
    OrderValidatorCode[OrderValidatorCode["ERC1155_NO_APPROVAL_FOR_ALL"] = 634] = "ERC1155_NO_APPROVAL_FOR_ALL";
    // 7. Asset-type errors
    OrderValidatorCode[OrderValidatorCode["POTENTIAL_INVALID_COLLECTION_TYPE_SHOULD_BE_ERC721"] = 701] = "POTENTIAL_INVALID_COLLECTION_TYPE_SHOULD_BE_ERC721";
    OrderValidatorCode[OrderValidatorCode["POTENTIAL_INVALID_COLLECTION_TYPE_SHOULD_BE_ERC1155"] = 702] = "POTENTIAL_INVALID_COLLECTION_TYPE_SHOULD_BE_ERC1155";
    // 8. Transfer manager-related errors
    OrderValidatorCode[OrderValidatorCode["NO_TRANSFER_MANAGER_APPROVAL_BY_USER_FOR_EXCHANGE"] = 801] = "NO_TRANSFER_MANAGER_APPROVAL_BY_USER_FOR_EXCHANGE";
    OrderValidatorCode[OrderValidatorCode["TRANSFER_MANAGER_APPROVAL_REVOKED_BY_OWNER_FOR_EXCHANGE"] = 802] = "TRANSFER_MANAGER_APPROVAL_REVOKED_BY_OWNER_FOR_EXCHANGE";
    // 9. Creator fee-related errors
    OrderValidatorCode[OrderValidatorCode["BUNDLE_ERC2981_NOT_SUPPORTED"] = 901] = "BUNDLE_ERC2981_NOT_SUPPORTED";
    OrderValidatorCode[OrderValidatorCode["CREATOR_FEE_TOO_HIGH"] = 902] = "CREATOR_FEE_TOO_HIGH";
})(OrderValidatorCode || (OrderValidatorCode = {}));

/**
 * Get additional params types for a maker order based on the strategy used
 * @param strategy Maker strategy
 * @returns Array of solidity types for encoding
 */
const getMakerParamsTypes = (strategy) => {
    if (strategy === StrategyType.standard || strategy === StrategyType.collection) {
        return [];
    }
    if (strategy === StrategyType.collectionWithMerkleTree) {
        return ["bytes32"]; // Merkle tree root
    }
    return [];
};
/**
 * Get additional params types for a maker order based on the strategy used
 * @param strategy Maker strategy
 * @returns Array of solidity types for encoding
 */
const getTakerParamsTypes = (strategy) => {
    if (strategy === StrategyType.standard) {
        return [];
    }
    if (strategy === StrategyType.collection) {
        return ["uint256"]; // Item id
    }
    if (strategy === StrategyType.collectionWithMerkleTree) {
        return ["uint256", "bytes32[]"]; // Item id, merkle proof
    }
    return [];
};
/**
 * Given an array of params, returns the encoded params.
 * To be used for orders signature and orders execution
 * @param params Array of params
 * @param types Array of solidity types
 * @returns encoded params
 */
const encodeParams = (params, types) => {
    return utils$1.defaultAbiCoder.encode(types, params);
};

var encode = /*#__PURE__*/Object.freeze({
  __proto__: null,
  encodeParams: encodeParams,
  getMakerParamsTypes: getMakerParamsTypes,
  getTakerParamsTypes: getTakerParamsTypes
});

const hexToBuffer = (value) => Buffer.from(value.slice(2), "hex");
const chunk = (array, size) => Array(Math.ceil(array.length / size))
    .fill(0)
    .map((_, i) => array.slice(i * size, (i + 1) * size));
const fillArray = (arr, length, value) => {
    const arrCopy = [...arr];
    if (length > arr.length) {
        arrCopy.push(...Array(length - arr.length).fill(value));
    }
    return arrCopy;
};
/**
 * Generic wrapper around MerkleTreeJS to support EIP signing
 */
class Eip712MerkleTree {
    /**
     *
     * @param types EIP712 Typed data
     * @param leafType Leaf type used in the Typed data
     * @param defaultNode Dummy node
     * @param elements Array of data blocks
     * @param depth tree depth
     */
    constructor(types, leafType, defaultNode, elements, depth) {
        this.types = types;
        this.leafType = leafType;
        this.elements = elements;
        this.depth = depth;
        const encoder = _TypedDataEncoder.from(types);
        const leafHasher = (leaf) => encoder.hashStruct(leafType, leaf);
        const leaves = this.elements.map(leafHasher);
        const defaultLeaf = leafHasher(defaultNode);
        this.completeLeaves = fillArray(leaves, this.completedSize, defaultLeaf);
        this.completeElements = fillArray(elements, this.completedSize, defaultNode);
        this.tree = new MerkleTree(this.completeLeaves.map(hexToBuffer), (value) => hexToBuffer(keccak256(value)), {
            sort: false,
            hashLeaves: false,
            fillDefaultHash: hexToBuffer(defaultLeaf),
        });
    }
    get completedSize() {
        return Math.pow(2, this.depth);
    }
    get hexRoot() {
        return this.tree.getHexRoot();
    }
    getPositionalProof(i) {
        const leaf = this.completeLeaves[i];
        const proof = this.tree.getPositionalHexProof(leaf, i);
        return { leaf, proof };
    }
    getDataToSign() {
        let layer = this.completeElements;
        while (layer.length > 2) {
            layer = chunk(layer, 2);
        }
        return { tree: layer };
    }
}
/**
 * Compute the tree height
 * @param length length of the array of elements
 * @returns height as a number
 */
Eip712MerkleTree.getTreeHeight = (length) => Math.max(Math.ceil(Math.log2(length)), 1);

// EIP 712 (Typed structured data hashing and signing) related data
// https://eips.ethereum.org/EIPS/eip-712
const MAKER_HASH = "0x003c1bce41a2de73dfe64d6eeb2b3d7f15f1c0c382d9d963c2c6daeb75f0e539";
const hashingMakerTypes = [
    "bytes32",
    "uint8",
    "uint256",
    "uint256",
    "uint256",
    "uint256",
    "uint8",
    "address",
    "address",
    "address",
    "uint256",
    "uint256",
    "uint256",
    "bytes32",
    "bytes32",
    "bytes32",
];
const makerTypes = {
    Maker: [
        { name: "quoteType", type: "uint8" },
        { name: "globalNonce", type: "uint256" },
        { name: "subsetNonce", type: "uint256" },
        { name: "orderNonce", type: "uint256" },
        { name: "strategyId", type: "uint256" },
        { name: "collectionType", type: "uint8" },
        { name: "collection", type: "address" },
        { name: "currency", type: "address" },
        { name: "signer", type: "address" },
        { name: "startTime", type: "uint256" },
        { name: "endTime", type: "uint256" },
        { name: "price", type: "uint256" },
        { name: "itemIds", type: "uint256[]" },
        { name: "amounts", type: "uint256[]" },
        { name: "additionalParameters", type: "bytes" },
    ],
};
const getBatchOrderTypes = (height) => {
    return {
        BatchOrder: [{ name: "tree", type: `Maker${`[2]`.repeat(height)}` }],
        Maker: [
            { name: "quoteType", type: "uint8" },
            { name: "globalNonce", type: "uint256" },
            { name: "subsetNonce", type: "uint256" },
            { name: "orderNonce", type: "uint256" },
            { name: "strategyId", type: "uint256" },
            { name: "collectionType", type: "uint8" },
            { name: "collection", type: "address" },
            { name: "currency", type: "address" },
            { name: "signer", type: "address" },
            { name: "startTime", type: "uint256" },
            { name: "endTime", type: "uint256" },
            { name: "price", type: "uint256" },
            { name: "itemIds", type: "uint256[]" },
            { name: "amounts", type: "uint256[]" },
            { name: "additionalParameters", type: "bytes" },
        ],
    };
};
/**
 * Hash maker ask order.
 * This function is used for testing purpose in the SDK, but is exposed because it's used by the BE.
 * @param maker Maker
 * @returns string (bytes32)
 */
const getMakerHash = (maker) => {
    const values = [
        MAKER_HASH,
        maker.quoteType,
        maker.globalNonce,
        maker.subsetNonce,
        maker.orderNonce,
        maker.strategyId,
        maker.collectionType,
        maker.collection,
        maker.currency,
        maker.signer,
        maker.startTime,
        maker.endTime,
        maker.price,
        utils$1.keccak256(utils$1.solidityPack(["uint256[]"], [maker.itemIds])),
        utils$1.keccak256(utils$1.solidityPack(["uint256[]"], [maker.amounts])),
        utils$1.keccak256(maker.additionalParameters),
    ];
    return utils$1.keccak256(utils$1.defaultAbiCoder.encode(hashingMakerTypes, values));
};

var eip712 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MAKER_HASH: MAKER_HASH,
  getBatchOrderTypes: getBatchOrderTypes,
  getMakerHash: getMakerHash,
  hashingMakerTypes: hashingMakerTypes,
  makerTypes: makerTypes
});

const defaultMaker = {
    quoteType: QuoteType.Bid,
    globalNonce: 0,
    subsetNonce: 0,
    orderNonce: 0,
    strategyId: StrategyType.standard,
    collectionType: CollectionType.ERC721,
    collection: constants.AddressZero,
    currency: constants.AddressZero,
    signer: constants.AddressZero,
    startTime: 0,
    endTime: 0,
    price: 0,
    itemIds: [0],
    amounts: [0],
    additionalParameters: "0x",
};
/**
 * Specific implementation of Eip712MerkleTree for Maker type
 * @extends Eip712MerkleTree
 */
class Eip712MakerMerkleTree extends Eip712MerkleTree {
    constructor(makerOrders) {
        const height = Eip712MerkleTree.getTreeHeight(makerOrders.length);
        const types = getBatchOrderTypes(height);
        super(types, "Maker", defaultMaker, makerOrders, height);
        this.makerOrders = makerOrders;
    }
}

/**
 * Sign a maker order
 * @param signer Ethers typed data signer
 * @param domain Typed data domain
 * @param makerOrder Maker order
 * @returns Signature
 */
const signMakerOrder = (signer, domain, makerOrder) => __awaiter(void 0, void 0, void 0, function* () {
    const signature = yield signer._signTypedData(domain, makerTypes, makerOrder);
    return utils$1.joinSignature(signature);
});
/**
 * Sign a list of maker orders with a merkle tree
 * @param signer Ethers typed data signer
 * @param domain Typed data domain
 * @param makerOrder Maker order
 * @returns Signature, array of proofs, and tree
 */
const signMerkleTreeOrders = (signer, domain, makerOrders) => __awaiter(void 0, void 0, void 0, function* () {
    const tree = new Eip712MakerMerkleTree(makerOrders);
    const hexRoot = tree.hexRoot;
    const merkleTreeProofs = makerOrders.map((_, index) => {
        const { proof } = tree.getPositionalProof(index);
        return {
            root: hexRoot,
            proof: proof.map((node) => {
                return {
                    position: node[0],
                    value: node[1],
                };
            }),
        };
    });
    const signature = yield signer._signTypedData(domain, tree.types, tree.getDataToSign());
    return { signature: utils$1.joinSignature(signature), merkleTreeProofs, tree };
});

var signMakerOrders = /*#__PURE__*/Object.freeze({
  __proto__: null,
  signMakerOrder: signMakerOrder,
  signMerkleTreeOrders: signMerkleTreeOrders
});

const mainnetAddresses = {
    LOOKS: "0xf4d2888d29D722226FafA5d9B24F9164c092421E",
    EXCHANGE_V2: "0x0000000000E655fAe4d56241588680F86E3b2377",
    TRANSFER_MANAGER_V2: "0x000000000060C4Ca14CfC4325359062ace33Fe3D",
    WETH: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    ORDER_VALIDATOR_V2: "0x2a784a5b5C8AE0bd738FBc67E4C069dB4F4961B7",
    REVERSE_RECORDS: "0x3671aE578E63FdF66ad4F3E12CC0c0d71Ac7510C",
    LOOKS_LP_V3: "0x4b5Ab61593A2401B1075b90c04cBCDD3F87CE011",
    STAKING_POOL_FOR_LOOKS_LP: "0x2A70e7F51f6cd40C3E9956aa964137668cBfAdC5",
    AGGREGATOR_UNISWAP_V3: "0x3ab16Af1315dc6C95F83Cbf522fecF98D00fd9ba",
};
const goerliAddresses = {
    LOOKS: "0x20A5A36ded0E4101C3688CBC405bBAAE58fE9eeC",
    EXCHANGE_V2: "0x35C2215F2FFe8917B06454eEEaba189877F200cf",
    TRANSFER_MANAGER_V2: "0xC20E0CeAD98abBBEb626B77efb8Dc1E5D781f90c",
    WETH: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6",
    ORDER_VALIDATOR_V2: "0x7454Cc9AEB024bcE6A2CDC49ad4733B4D8215fb8",
    REVERSE_RECORDS: "0x333Fc8f550043f239a2CF79aEd5e9cF4A20Eb41e",
    LOOKS_LP_V3: "0x87C81267796Cd65347130e789CADdCdAf7bD2231",
    STAKING_POOL_FOR_LOOKS_LP: "",
    AGGREGATOR_UNISWAP_V3: "0x63c38B3BE3eF075a00a5edaeC36F499088c7334C",
};
const sepoliaAddresses = {
    LOOKS: "0xa68c2CaA3D45fa6EBB95aA706c70f49D3356824E",
    EXCHANGE_V2: "0x34098cc15a8a48Da9d3f31CC0F63F01f9aa3D9F3",
    TRANSFER_MANAGER_V2: "0xb46f116ecBa8451E661189F4b2B63aC60a618092",
    WETH: "0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14",
    ORDER_VALIDATOR_V2: "0x0bc129E4c1f8D7b5583eAbAeb1F7468935B6ec0C",
    REVERSE_RECORDS: "",
    LOOKS_LP_V3: "",
    STAKING_POOL_FOR_LOOKS_LP: "",
    AGGREGATOR_UNISWAP_V3: "",
};
const arbitrumSepoliaAddresses = {
    LOOKS: "",
    EXCHANGE_V2: "",
    TRANSFER_MANAGER_V2: "",
    WETH: "",
    ORDER_VALIDATOR_V2: "",
    REVERSE_RECORDS: "",
    LOOKS_LP_V3: "",
    STAKING_POOL_FOR_LOOKS_LP: "",
    AGGREGATOR_UNISWAP_V3: "",
};
const arbitrumMainnetAddresses = {
    LOOKS: "",
    EXCHANGE_V2: "",
    TRANSFER_MANAGER_V2: "",
    WETH: "",
    ORDER_VALIDATOR_V2: "",
    REVERSE_RECORDS: "",
    LOOKS_LP_V3: "",
    STAKING_POOL_FOR_LOOKS_LP: "",
    AGGREGATOR_UNISWAP_V3: "",
};
const baseMainnetAddresses = {
    LOOKS: "",
    EXCHANGE_V2: "",
    TRANSFER_MANAGER_V2: "",
    WETH: "",
    ORDER_VALIDATOR_V2: "",
    REVERSE_RECORDS: "",
    LOOKS_LP_V3: "",
    STAKING_POOL_FOR_LOOKS_LP: "",
    AGGREGATOR_UNISWAP_V3: "",
};
const baseSepoliaAddresses = {
    LOOKS: "",
    EXCHANGE_V2: "",
    TRANSFER_MANAGER_V2: "",
    WETH: "",
    ORDER_VALIDATOR_V2: "",
    REVERSE_RECORDS: "",
    LOOKS_LP_V3: "",
    STAKING_POOL_FOR_LOOKS_LP: "",
    AGGREGATOR_UNISWAP_V3: "",
};
const blastSepoliaAddresses = {
    LOOKS: "",
    EXCHANGE_V2: "",
    TRANSFER_MANAGER_V2: "",
    WETH: "",
    ORDER_VALIDATOR_V2: "",
    REVERSE_RECORDS: "",
    LOOKS_LP_V3: "",
    STAKING_POOL_FOR_LOOKS_LP: "",
    AGGREGATOR_UNISWAP_V3: "",
};
/**
 * List of useful contract addresses
 */
const addressesByNetwork = {
    [ChainId.MAINNET]: mainnetAddresses,
    [ChainId.GOERLI]: goerliAddresses,
    [ChainId.HARDHAT]: goerliAddresses,
    [ChainId.SEPOLIA]: sepoliaAddresses,
    [ChainId.ARB_SEPOLIA]: arbitrumSepoliaAddresses,
    [ChainId.ARB_MAINNET]: arbitrumMainnetAddresses,
    [ChainId.BASE_MAINNET]: baseMainnetAddresses,
    [ChainId.BASE_SEPOLIA]: baseSepoliaAddresses,
    [ChainId.BLAST_SEPOLIA]: blastSepoliaAddresses,
};

const chainInfo = {
    [ChainId.MAINNET]: {
        label: "Ethereum",
        appUrl: "https://looksrare.org",
        explorer: "https://etherscan.io",
        rpcUrl: "https://eth-mainnet.g.alchemy.com/v2",
        baseApiUrl: "https://graphql.looksrare.org",
        osApiUrl: "https://api.opensea.io",
        cdnUrl: "https://static.looksnice.org",
        rewardsSubgraphUrl: "https://api.thegraph.com/subgraphs/name/looksrare/looks-distribution",
        cloudinaryUrl: "https://looksrare.mo.cloudinary.net",
        wsUrl: "wss://ws.looksrare.org/ws",
    },
    [ChainId.GOERLI]: {
        label: "Goerli",
        appUrl: "https://goerli.looksrare.org",
        explorer: "https://goerli.etherscan.io",
        rpcUrl: "https://eth-goerli.g.alchemy.com/v2",
        baseApiUrl: "https://graphql-goerli.looksrare.org",
        osApiUrl: "https://testnets-api.opensea.io",
        cdnUrl: "https://static-goerli.looksnice.org",
        rewardsSubgraphUrl: "https://api.thegraph.com/subgraphs/name/0xjurassicpunk/looks-distribution",
        cloudinaryUrl: "https://looksrare.mo.cloudinary.net/goerli",
        wsUrl: "wss://ws-goerli.looksrare.org/ws",
    },
    [ChainId.SEPOLIA]: {
        label: "Sepolia",
        appUrl: "https://sepolia.looksrare.org",
        explorer: "https://sepolia.etherscan.io",
        rpcUrl: "https://eth-sepolia.g.alchemy.com/v2",
        baseApiUrl: "https://graphql-sepolia.looksrare.org",
        osApiUrl: "https://testnets-api.opensea.io",
        cdnUrl: "https://static-sepolia.looksnice.org",
        rewardsSubgraphUrl: "https://api.thegraph.com/subgraphs/name/0xjurassicpunk/looks-distribution",
        cloudinaryUrl: "https://looksrare.mo.cloudinary.net/sepolia",
        wsUrl: "wss://ws-sepolia.looksrare.org/ws",
    },
    [ChainId.ARB_MAINNET]: {
        label: "Arbitrum",
        appUrl: "https://looksrare.org",
        explorer: "https://arbiscan.io",
        rpcUrl: "https://arb-mainnet.g.alchemy.com/v2",
        baseApiUrl: "https://graphql.looksrare.org",
        osApiUrl: "https://api.opensea.io",
        cdnUrl: "https://static.looksnice.org",
        rewardsSubgraphUrl: "https://api.thegraph.com/subgraphs/name/looksrare/looks-distribution",
        cloudinaryUrl: "https://looksrare.mo.cloudinary.net",
        wsUrl: "wss://ws.looksrare.org/ws",
    },
    [ChainId.ARB_SEPOLIA]: {
        label: "Arbitrum Sepolia",
        appUrl: "https://sepolia.looksrare.org",
        explorer: "https://sepolia.arbiscan.io",
        rpcUrl: "https://arb-sepolia.g.alchemy.com/v2",
        baseApiUrl: "https://graphql-sepolia.looksrare.org",
        osApiUrl: "https://testnets-api.opensea.io",
        cdnUrl: "https://static-sepolia.looksnice.org",
        rewardsSubgraphUrl: "https://api.thegraph.com/subgraphs/name/0xjurassicpunk/looks-distribution",
        cloudinaryUrl: "https://looksrare.mo.cloudinary.net/sepolia",
        wsUrl: "wss://ws-sepolia.looksrare.org/ws",
    },
    [ChainId.BASE_MAINNET]: {
        label: "Base Mainnet",
        appUrl: "https://looksrare.org",
        explorer: "https://basescan.org",
        rpcUrl: "https://base-mainnet.g.alchemy.com/v2",
        baseApiUrl: "https://graphql.looksrare.org",
        osApiUrl: "https://api.opensea.io",
        cdnUrl: "https://static.looksnice.org",
        rewardsSubgraphUrl: "https://api.thegraph.com/subgraphs/name/looksrare/looks-distribution",
        cloudinaryUrl: "https://looksrare.mo.cloudinary.net",
        wsUrl: "wss://ws.looksrare.org/ws",
    },
    [ChainId.BASE_SEPOLIA]: {
        label: "Base Sepolia",
        appUrl: "https://sepolia.looksrare.org",
        explorer: "https://sepolia-explorer.base.org",
        rpcUrl: "https://base-sepolia.g.alchemy.com/v2",
        baseApiUrl: "https://graphql-sepolia.looksrare.org",
        osApiUrl: "https://testnets-api.opensea.io",
        cdnUrl: "https://static-sepolia.looksnice.org",
        rewardsSubgraphUrl: "https://api.thegraph.com/subgraphs/name/0xjurassicpunk/looks-distribution",
        cloudinaryUrl: "https://looksrare.mo.cloudinary.net/sepolia",
        wsUrl: "wss://ws-sepolia.looksrare.org/ws",
    },
    [ChainId.HARDHAT]: {
        label: "Hardhat",
        appUrl: "http://localhost:3000",
        explorer: "https://etherscan.io",
        rpcUrl: "http://127.0.0.1:8545",
        baseApiUrl: "http://localhost:4000",
        osApiUrl: "https://testnets-api.opensea.io",
        cdnUrl: "https://via.placeholder.com",
        rewardsSubgraphUrl: "https://api.thegraph.com/subgraphs/name/0xjurassicpunk/looks-distribution",
        cloudinaryUrl: "",
        wsUrl: "ws://localhost:5001/ws",
    },
    [ChainId.BLAST_SEPOLIA]: {
        label: "Blast Sepolia",
        appUrl: "https://sepolia.looksrare.org",
        explorer: "https://testnet.blastscan.io/",
        rpcUrl: "https://sepolia.blast.io",
        baseApiUrl: "https://graphql-sepolia.looksrare.org",
        osApiUrl: "https://testnets-api.opensea.io",
        cdnUrl: "https://static-sepolia.looksnice.org",
        rewardsSubgraphUrl: "https://api.thegraph.com/subgraphs/name/0xjurassicpunk/looks-distribution",
        cloudinaryUrl: "https://looksrare.mo.cloudinary.net/sepolia",
        wsUrl: "wss://ws-sepolia.looksrare.org/ws",
    },
    [ChainId.BLAST_MAINNET]: {
        appUrl: "https://yologames.io",
        baseApiUrl: "https://graphql.yologames.io",
        // For potential backwards compatibility of asset urls
        // use looksnice. Important to note this should not actually be called.
        cdnUrl: "https://static.looksnice.org",
        cloudinaryUrl: "https://looksrare.mo.cloudinary.net",
        explorer: "https://blastscan.io",
        label: "Blast",
        osApiUrl: "",
        rewardsSubgraphUrl: "",
        rpcUrl: "https://rpc.blast.io",
        wsUrl: "wss://ws.yologames.io/ws",
    },
};

/** Maximum amount of orders in a merkle tree
 * This limit is enforced in the contract with the value 2^10 (=1024)
 * @see {@link https://github.com/LooksRare/contracts-exchange-v2/blob/master/contracts/constants/NumericConstants.sol#L7}
 */
const MAX_ORDERS_PER_TREE = 1024;
/**
 * Default merkle tree value used when the merkle tree can be omitted.
 */
const defaultMerkleTree = { root: constants.HashZero, proof: [] };

/** Invalid timestamp format */
class ErrorTimestamp extends Error {
    constructor() {
        super("Timestamps should be in seconds");
        this.name = "ErrorTimestamp";
    }
}
/** Undefined signer */
class ErrorSigner extends Error {
    constructor() {
        super("Signer is undefined");
        this.name = "ErrorSigner";
    }
}
/** Too many orders in one merkle tree */
class ErrorMerkleTreeDepth extends Error {
    constructor() {
        super(`Too many orders (limit: ${MAX_ORDERS_PER_TREE})`);
        this.name = "ErrorMerkleTreeDepth";
    }
}
/** Wrong quote type */
class ErrorQuoteType extends Error {
    constructor() {
        super("Wrong quote type");
        this.name = "ErrorQuoteType";
    }
}
/** Wrong strategy type */
class ErrorStrategyType extends Error {
    constructor() {
        super("Wrong strategy type");
        this.name = "ErrorStrategyType";
    }
}
/** Invalid item ID for orders with proof */
class ErrorItemId extends Error {
    constructor() {
        super("Item id is not in the list");
        this.name = "ErrorItemId";
    }
}

var IERC1155 = [
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "operator",
				type: "address"
			},
			{
				indexed: false,
				internalType: "bool",
				name: "approved",
				type: "bool"
			}
		],
		name: "ApprovalForAll",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "operator",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256[]",
				name: "ids",
				type: "uint256[]"
			},
			{
				indexed: false,
				internalType: "uint256[]",
				name: "values",
				type: "uint256[]"
			}
		],
		name: "TransferBatch",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "operator",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "id",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "TransferSingle",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "string",
				name: "value",
				type: "string"
			},
			{
				indexed: true,
				internalType: "uint256",
				name: "id",
				type: "uint256"
			}
		],
		name: "URI",
		type: "event"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "id",
				type: "uint256"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address[]",
				name: "accounts",
				type: "address[]"
			},
			{
				internalType: "uint256[]",
				name: "ids",
				type: "uint256[]"
			}
		],
		name: "balanceOfBatch",
		outputs: [
			{
				internalType: "uint256[]",
				name: "",
				type: "uint256[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "address",
				name: "operator",
				type: "address"
			}
		],
		name: "isApprovedForAll",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256[]",
				name: "ids",
				type: "uint256[]"
			},
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "safeBatchTransferFrom",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "id",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "safeTransferFrom",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "operator",
				type: "address"
			},
			{
				internalType: "bool",
				name: "approved",
				type: "bool"
			}
		],
		name: "setApprovalForAll",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var WETH = [
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "Deposit",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "Withdrawal",
		type: "event"
	},
	{
		inputs: [
		],
		name: "DOMAIN_SEPARATOR",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				internalType: "uint8",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "deposit",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "name",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "nonces",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "permit",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "withdraw",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		stateMutability: "payable",
		type: "receive"
	}
];

/**
 * Name of the LooksRare contract. Used for EIP712 domain separator.
 * @see {@link https://eips.ethereum.org/EIPS/eip-712#definition-of-domainseparator EIP712 doc}
 */
const contractName = "LooksRareProtocol";
/**
 * Protocol version. Used for EIP712 domain separator.
 * @see {@link https://eips.ethereum.org/EIPS/eip-712#definition-of-domainseparator EIP712 doc}
 */
const version = 2;

/**
 * LooksRare
 * This class provides helpers to interact with the LooksRare V2 contracts
 */
class LooksRare {
    /**
     * LooksRare protocol main class
     * @param chainId Current app chain id
     * @param provider Ethers provider
     * @param signer Ethers signer
     * @param override Overrides contract addresses for hardhat setup
     */
    constructor(chainId, provider, signer, override) {
        this.chainId = chainId;
        this.addresses = override !== null && override !== void 0 ? override : addressesByNetwork[this.chainId];
        this.signer = signer;
        this.provider = new multicall.providers.MulticallProvider(provider);
    }
    /**
     * Return the signer it it's set, throw an exception otherwise
     * @returns Signer
     */
    getSigner() {
        if (!this.signer) {
            throw new ErrorSigner();
        }
        return this.signer;
    }
    /**
     * Validate a timestamp format (seconds)
     * @param timestamp
     * @returns boolean
     */
    isTimestampValid(timestamp) {
        return BigNumber.from(timestamp).toString().length <= 10;
    }
    /**
     * Retrieve EIP-712 domain
     * @returns TypedDataDomain
     */
    getTypedDataDomain() {
        return {
            name: contractName,
            version: version.toString(),
            chainId: this.chainId,
            verifyingContract: this.addresses.EXCHANGE_V2,
        };
    }
    /**
     * Create a maker ask object ready to be signed
     * @param CreateMakerInput
     * @returns the maker object, isTransferManagerApproved, and isTransferManagerApproved
     */
    createMakerAsk({ collection, strategyId, collectionType, subsetNonce, orderNonce, endTime, price, itemIds, amounts = [1], currency = constants.AddressZero, startTime = Math.floor(Date.now() / 1000), additionalParameters = [], }) {
        return __awaiter(this, void 0, void 0, function* () {
            const signer = this.getSigner();
            if (!this.isTimestampValid(startTime) || !this.isTimestampValid(endTime)) {
                throw new ErrorTimestamp();
            }
            const signerAddress = yield signer.getAddress();
            const spenderAddress = this.addresses.TRANSFER_MANAGER_V2;
            // Use this.provider (MulticallProvider) in order to batch the calls
            const [isCollectionApproved, userBidAskNonce, isTransferManagerApproved] = yield Promise.all([
                isApprovedForAll(this.provider, collection, signerAddress, spenderAddress),
                viewUserBidAskNonces(this.provider, this.addresses.EXCHANGE_V2, signerAddress),
                hasUserApprovedOperator(this.provider, this.addresses.TRANSFER_MANAGER_V2, signerAddress, this.addresses.EXCHANGE_V2),
            ]);
            const order = {
                quoteType: QuoteType.Ask,
                globalNonce: userBidAskNonce.askNonce,
                subsetNonce: subsetNonce,
                strategyId: strategyId,
                collectionType: collectionType,
                orderNonce: orderNonce,
                collection: collection,
                currency: currency,
                signer: signerAddress,
                startTime: startTime,
                endTime: endTime,
                price: price,
                itemIds: itemIds,
                amounts: amounts,
                additionalParameters: encodeParams(additionalParameters, getMakerParamsTypes(strategyId)),
            };
            return {
                maker: order,
                isTransferManagerApproved,
                isCollectionApproved,
            };
        });
    }
    /**
     * Create a maker bid object ready to be signed
     * @param CreateMakerInput
     * @returns the maker object, isCurrencyApproved, and isBalanceSufficient
     */
    createMakerBid({ collection, strategyId, collectionType, subsetNonce, orderNonce, endTime, price, itemIds, amounts = [1], currency = this.addresses.WETH, startTime = Math.floor(Date.now() / 1000), additionalParameters = [], }) {
        return __awaiter(this, void 0, void 0, function* () {
            const signer = this.getSigner();
            if (!this.isTimestampValid(startTime) || !this.isTimestampValid(endTime)) {
                throw new ErrorTimestamp();
            }
            const signerAddress = yield signer.getAddress();
            const spenderAddress = this.addresses.EXCHANGE_V2;
            // Use this.provider (MulticallProvider) in order to batch the calls
            const [balance, currentAllowance, userBidAskNonce] = yield Promise.all([
                balanceOf(this.provider, currency, signerAddress),
                allowance(this.provider, currency, signerAddress, spenderAddress),
                viewUserBidAskNonces(this.provider, this.addresses.EXCHANGE_V2, signerAddress),
            ]);
            const order = {
                quoteType: QuoteType.Bid,
                globalNonce: userBidAskNonce.bidNonce,
                subsetNonce: subsetNonce,
                strategyId: strategyId,
                collectionType: collectionType,
                orderNonce: orderNonce,
                collection: collection,
                currency: currency,
                signer: signerAddress,
                startTime: startTime,
                endTime: endTime,
                price: price,
                itemIds: itemIds,
                amounts: amounts,
                additionalParameters: encodeParams(additionalParameters, getMakerParamsTypes(strategyId)),
            };
            return {
                maker: order,
                isCurrencyApproved: BigNumber.from(currentAllowance).gte(price),
                isBalanceSufficient: BigNumber.from(balance).gte(price),
            };
        });
    }
    /**
     * Create a maker bid for collection offer.
     * @see this.createMakerBid
     * @param orderInputs Order data
     * @returns CreateMakerBidOutput
     */
    createMakerCollectionOffer(orderInputs) {
        return this.createMakerBid(Object.assign(Object.assign({}, orderInputs), { strategyId: StrategyType.collection, itemIds: [] }));
    }
    /**
     * Create a maker bid for collection, with a list of item id that can be used for the taker order
     * @see this.createMakerBid
     * @param orderInputs Order data
     * @returns CreateMakerBidOutput
     */
    createMakerCollectionOfferWithProof(orderInputs) {
        return __awaiter(this, void 0, void 0, function* () {
            const { itemIds } = orderInputs, otherInputs = __rest(orderInputs, ["itemIds"]);
            const leaves = itemIds.map((itemId) => {
                const hash = utils$1.keccak256(utils$1.solidityPack(["uint256"], [itemId]));
                return Buffer.from(hash.slice(2), "hex");
            });
            const tree = new MerkleTree(leaves, keccak256$1, { sortPairs: true });
            const root = tree.getHexRoot();
            return this.createMakerBid(Object.assign(Object.assign({}, otherInputs), { strategyId: StrategyType.collectionWithMerkleTree, additionalParameters: [root], itemIds: [] }));
        });
    }
    /**
     * Create a taker ask ready to be executed against a maker bid
     * @param maker Maker order that will be used as counterparty for the taker
     * @param recipient Recipient address of the taker (if none, it will use the sender)
     * @param additionalParameters Additional parameters used to support complex orders
     * @returns Taker object
     */
    createTaker(maker, recipient = constants.AddressZero, additionalParameters = []) {
        const order = {
            recipient: recipient,
            additionalParameters: encodeParams(additionalParameters, getTakerParamsTypes(maker.strategyId)),
        };
        return order;
    }
    /**
     * Create a taker ask order for collection order.
     * @see this.createTaker
     * @see this.createMakerCollectionOffer
     * @param makerBid Maker bid that will be used as counterparty for the taker
     * @param itemId Token id to use as a counterparty for the collection order
     * @param recipient Recipient address of the taker (if none, it will use the sender)
     * @returns Taker object
     */
    createTakerCollectionOffer(maker, itemId, recipient) {
        if (maker.quoteType !== QuoteType.Bid) {
            throw new ErrorQuoteType();
        }
        if (maker.strategyId !== StrategyType.collection) {
            throw new ErrorStrategyType();
        }
        return this.createTaker(maker, recipient, [itemId]);
    }
    /**
     * Create a taker ask to fulfill a collection order (maker bid) created with a whitelist of item ids
     * @see this.createTaker
     * @see this.createMakerCollectionOfferWithMerkleTree
     * @param makerBid Maker bid that will be used as counterparty for the taker
     * @param itemId Token id to use as a counterparty for the collection order
     * @param itemIds List of token ids used during the maker creation
     * @param recipient Recipient address of the taker (if none, it will use the sender)
     * @returns Taker object
     */
    createTakerCollectionOfferWithProof(maker, itemId, itemIds, recipient) {
        if (maker.quoteType !== QuoteType.Bid) {
            throw new ErrorQuoteType();
        }
        if (maker.strategyId !== StrategyType.collectionWithMerkleTree) {
            throw new ErrorStrategyType();
        }
        const index = itemIds.findIndex((id) => BigNumber.from(id).eq(itemId));
        if (index === -1) {
            throw new ErrorItemId();
        }
        const leaves = itemIds.map((id) => {
            const hash = utils$1.keccak256(utils$1.solidityPack(["uint256"], [id]));
            return Buffer.from(hash.slice(2), "hex");
        });
        const tree = new MerkleTree(leaves, keccak256$1, { sortPairs: true });
        const proof = tree.getHexProof(leaves[index]);
        return this.createTaker(maker, recipient, [itemId, proof]);
    }
    /**
     * Sign a maker order using the signer provided in the constructor
     * @param maker Order to be signed by the user
     * @returns Signature
     */
    signMakerOrder(maker) {
        return __awaiter(this, void 0, void 0, function* () {
            const signer = this.getSigner();
            return yield signMakerOrder(signer, this.getTypedDataDomain(), maker);
        });
    }
    /**
     * Sign multiple maker orders with a single signature
     * /!\ Use this function for UI implementation only
     * @param makerOrders Array of maker orders
     * @returns Signature, proofs, and Merkletree object
     */
    signMultipleMakerOrders(makerOrders) {
        return __awaiter(this, void 0, void 0, function* () {
            if (makerOrders.length > MAX_ORDERS_PER_TREE) {
                throw new ErrorMerkleTreeDepth();
            }
            const signer = this.getSigner();
            return signMerkleTreeOrders(signer, this.getTypedDataDomain(), makerOrders);
        });
    }
    /**
     * Execute a trade
     * @param makerBid Maker order
     * @param taker Taker order
     * @param signature Signature of the maker order
     * @param merkleTree If the maker has been signed with a merkle tree
     * @param affiliate Affiliate address if applicable
     * @returns ContractMethods
     */
    executeOrder(maker, taker, signature, merkleTree = defaultMerkleTree, affiliate = constants.AddressZero, overrides) {
        const signer = this.getSigner();
        const execute = maker.quoteType === QuoteType.Ask ? executeTakerBid : executeTakerAsk;
        return execute(signer, this.addresses.EXCHANGE_V2, taker, maker, signature, merkleTree, affiliate, overrides);
    }
    /**
     * Execute several orders
     * @param orders List of orders data
     * @param isAtomic Should the transaction revert or not if a trade fails
     * @param affiliate Affiliate address
     * @param overrides Call overrides
     * @returns ContractMethods
     */
    executeMultipleOrders(orders, isAtomic, affiliate = constants.AddressZero, overrides) {
        const signer = this.getSigner();
        const makers = [];
        const takers = [];
        const signatures = [];
        const merkleTrees = [];
        orders.forEach((order) => {
            var _a;
            if (order.maker.quoteType === QuoteType.Bid) {
                throw new ErrorQuoteType();
            }
            makers.push(order.maker);
            takers.push(order.taker);
            signatures.push(order.signature);
            merkleTrees.push((_a = order.merkleTree) !== null && _a !== void 0 ? _a : defaultMerkleTree);
        });
        return executeMultipleTakerBids(signer, this.addresses.EXCHANGE_V2, takers, makers, signatures, isAtomic, merkleTrees, affiliate, overrides);
    }
    /**
     * Cancell all maker bid and/or ask orders for the current user
     * @param bid Cancel all bids
     * @param ask Cancel all asks
     * @returns ContractMethods
     */
    cancelAllOrders(bid, ask, overrides) {
        const signer = this.getSigner();
        return incrementBidAskNonces(signer, this.addresses.EXCHANGE_V2, bid, ask, overrides);
    }
    /**
     * Cancel a list of specific orders
     * @param nonces List of nonces to be cancelled
     * @returns ContractMethods
     */
    cancelOrders(nonces, overrides) {
        const signer = this.getSigner();
        return cancelOrderNonces(signer, this.addresses.EXCHANGE_V2, nonces, overrides);
    }
    /**
     * Cancel a list of specific subset orders
     * @param nonces List of nonces to be cancelled
     * @returns ContractMethods
     */
    cancelSubsetOrders(nonces, overrides) {
        const signer = this.getSigner();
        return cancelSubsetNonces(signer, this.addresses.EXCHANGE_V2, nonces, overrides);
    }
    /**
     * Approve all the items of a collection, to eventually be traded on LooksRare
     * The spender is the TransferManager.
     * @param collectionAddress Address of the collection to be approved.
     * @param approved true to approve, false to revoke the approval (default to true)
     * @returns ContractTransaction
     */
    approveAllCollectionItems(collectionAddress, approved = true, overrides) {
        const signer = this.getSigner();
        const spenderAddress = this.addresses.TRANSFER_MANAGER_V2;
        return setApprovalForAll(signer, collectionAddress, spenderAddress, approved, overrides);
    }
    /**
     * Approve an ERC20 to be used as a currency on LooksRare.
     * The spender is the LooksRareProtocol contract.
     * @param tokenAddress Address of the ERC20 to approve
     * @param amount Amount to be approved (default to MaxUint256)
     * @returns ContractTransaction
     */
    approveErc20(tokenAddress, amount = constants.MaxUint256, overrides) {
        const signer = this.getSigner();
        const spenderAddress = this.addresses.EXCHANGE_V2;
        return approve(signer, tokenAddress, spenderAddress, amount, overrides);
    }
    /**
     * Check whether or not an operator has been approved by the user
     * @param operator Operator address (default to the exchange address)
     * @returns true if the operator is approved, false otherwise
     */
    isTransferManagerApproved(operator = this.addresses.EXCHANGE_V2, overrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const signer = this.getSigner();
            const signerAddress = yield signer.getAddress();
            return hasUserApprovedOperator(signer, this.addresses.TRANSFER_MANAGER_V2, signerAddress, operator, overrides);
        });
    }
    /**
     * Grant a list of operators the rights to transfer user's assets using the transfer manager
     * @param operators List of operators (default to the exchange address)
     * @defaultValue Exchange address
     * @returns ContractMethods
     */
    grantTransferManagerApproval(operators = [this.addresses.EXCHANGE_V2], overrides) {
        const signer = this.getSigner();
        return grantApprovals(signer, this.addresses.TRANSFER_MANAGER_V2, operators, overrides);
    }
    /**
     * Revoke a list of operators the rights to transfer user's assets using the transfer manager
     * @param operators List of operators
     * @defaultValue Exchange address
     * @returns ContractMethods
     */
    revokeTransferManagerApproval(operators = [this.addresses.EXCHANGE_V2], overrides) {
        const signer = this.getSigner();
        return revokeApprovals(signer, this.addresses.TRANSFER_MANAGER_V2, operators, overrides);
    }
    /**
     * Transfer a list of items across different collections
     * @param to Recipient address
     * @param collectionItems Each object in the array represent a list of items for a specific collection
     * @returns ContractMethods
     */
    transferItemsAcrossCollection(to, collectionItems, overrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const signer = this.getSigner();
            const from = yield signer.getAddress();
            return transferBatchItemsAcrossCollections(signer, this.addresses.TRANSFER_MANAGER_V2, collectionItems, from, to, overrides);
        });
    }
    /**
     * Verify if a set of orders can be executed (i.e are valid)
     * @param makerOrders List of maker orders
     * @param signatures List of signatures
     * @param merkleTrees List of merkle trees (optional)
     * @returns A list of OrderValidatorCode for each order (code 0 being valid)
     */
    verifyMakerOrders(makerOrders, signatures, merkleTrees, overrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const _merkleTrees = merkleTrees !== null && merkleTrees !== void 0 ? merkleTrees : makerOrders.map(() => defaultMerkleTree);
            return verifyMakerOrders(this.provider, this.addresses.ORDER_VALIDATOR_V2, makerOrders, signatures, _merkleTrees, overrides);
        });
    }
    /**
     * Retrieve strategy info
     * @param strategyId use the enum StrategyType
     * @returns StrategyInfo
     */
    strategyInfo(strategyId, overrides) {
        return __awaiter(this, void 0, void 0, function* () {
            return strategyInfo(this.provider, this.addresses.EXCHANGE_V2, strategyId, overrides);
        });
    }
}

const utils = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, tokens), exchange), nonces), transferManager), orderValidator), strategies), encode), signMakerOrders), eip712);

export { ChainId, CollectionType, Eip712MakerMerkleTree, Eip712MerkleTree, ErrorItemId, ErrorMerkleTreeDepth, ErrorQuoteType, ErrorSigner, ErrorStrategyType, ErrorTimestamp, IERC1155 as IERC1155Abi, abiIERC20 as IERC20Abi, abiIERC721 as IERC721Abi, LooksRare, abi$2 as LooksRareProtocolAbi, MAX_ORDERS_PER_TREE, MerkleTreeNodePosition, OrderValidatorCode, abi as OrderValidatorV2AAbi, QuoteType, StrategyType, abi$1 as TransferManagerAbi, WETH as WETHAbi, addressesByNetwork, chainInfo, defaultMerkleTree, utils };
